import e from"../../../../../rollup-plugin-node-polyfills/polyfills/process-es6.js";var o="object"==typeof e&&e.env&&e.env.NODE_DEBUG&&/\bsemver\b/i.test(e.env.NODE_DEBUG)?(...e)=>console.error("SEMVER",...e):()=>{};export{o as d};
